import { Component } from "react";
import * as React from "react";
import { Icon, Label, ColorPicker, IColor } from "office-ui-fabric-react";
import School from "../../../models/School";
import * as _ from "lodash";
import { SchoolTheme } from "./SchoolTheme";

const COLOUR_1_HUMAN_NAME = "Theme Background";
const COLOUR_2_HUMAN_NAME  = "Theme Accent";

export interface SchoolThemeCardProps {
    school: School;
    schoolTheme: SchoolTheme;
    onSchoolThemeChanged(updatedSchoolTheme: SchoolTheme): void;
}

export interface SchoolThemeCardState {
}

export class SchoolThemeCard extends Component<SchoolThemeCardProps, SchoolThemeCardState>
{
    constructor(props: Readonly<SchoolThemeCardProps>) {
        super(props);

        this.state = {
        };
    }


    componentDidUpdate(prevProps: Readonly<SchoolThemeCardProps>, prevState: Readonly<SchoolThemeCardState>, snapshot?: any): void {
    }

    public componentDidMount() {

        const defaultedSchoolTheme: SchoolTheme = _.cloneDeep(this.props.schoolTheme);
        defaultedSchoolTheme.colour1 = this.props.schoolTheme.colour1 ?? "#000000";
        defaultedSchoolTheme.colour2 = this.props.schoolTheme.colour2 ?? "#000000";
        defaultedSchoolTheme.colour3 = null;
        defaultedSchoolTheme.megaMenuBgColour = this.props.schoolTheme.megaMenuBgColour ?? "#000000";
        defaultedSchoolTheme.megaMenuFontColour = this.props.schoolTheme.megaMenuFontColour ?? "#000000";
        this.props.onSchoolThemeChanged(defaultedSchoolTheme);

    }

    private setColor = (c: IColor, name: string) => {
        const updatedSchoolTheme: any = _.cloneDeep(this.props.schoolTheme);

        updatedSchoolTheme[name] = c.str;

        this.props.onSchoolThemeChanged(updatedSchoolTheme);
    }

    public render() {
        return (
            <div className="card">

                <div className="card__header">
                    <Icon iconName="Menu" className={"p-left-1rem"} />
                    <div className="card__title">
                        <span>Your School Theme</span>
                    </div>
                    {this.props.children}
                </div>

                <div className="card__flexcontent flex-column">
                    <Label className="card__label">
                        {COLOUR_1_HUMAN_NAME}
                        <br/>
                        <span className={"text-extra-detail"}>Please choose a dark colour from the school website. This applies to:
                            <li>Web part backgrounds</li>
                            <li>Site sections with strong emphasis</li>
                            <li>Quick link tiles</li>
                        </span>
                    </Label>
                    <Label className="card__label">
                        {COLOUR_2_HUMAN_NAME}
                        <br/>
                        <span className={"text-extra-detail"}>
                            Usually the Mega Menu colour, but if the Mega Menu is white then use a darker colour such as the O365 banner background or the App Launcher colour. This applies to:
                            <li>My profile web part</li>
                            <li>Class dashboard</li>
                        </span>
                    </Label>
                </div>

                <div className="card__flexcontent">
                    <div>
                        <Label className="card__label">{COLOUR_1_HUMAN_NAME}</Label>
                        <ColorPicker color={this.props.schoolTheme.colour1} onChange={(_e, c) => this.setColor(c, "colour1")} />
                    </div>

                    <div>
                        <Label className="card__label">{COLOUR_2_HUMAN_NAME}</Label>
                        <ColorPicker color={this.props.schoolTheme.colour2} onChange={(_e, c) => this.setColor(c, "colour2")} />
                    </div>

                    <div>
                        <Label className="card__label">Mega Menu Background Colour</Label>
                        <ColorPicker color={this.props.schoolTheme.megaMenuBgColour} onChange={(_e, c) => this.setColor(c, "megaMenuBgColour")} alphaSliderHidden={true} />
                    </div>

                    <div>
                        <Label className="card__label">Mega Menu Font Colour</Label>
                        <ColorPicker color={this.props.schoolTheme.megaMenuFontColour} onChange={(_e, c) => this.setColor(c, "megaMenuFontColour")} alphaSliderHidden={true} />
                    </div>
                </div>
            </div>
        );
    }
}